import React from 'react';
import { VisuallyHiddenLegend, FieldSet } from '../styles';

var RadioGroup = function RadioGroup(_ref) {
  var dataTest = _ref['data-test'],
      className = _ref.className,
      legend = _ref.legend,
      hideLegend = _ref.hideLegend,
      name = _ref.name,
      _onChange = _ref.onChange,
      children = _ref.children,
      selectedIndex = _ref.selectedIndex;
  return /*#__PURE__*/React.createElement(FieldSet, {
    className: className,
    "data-test": dataTest ? dataTest : undefined
  }, hideLegend ? /*#__PURE__*/React.createElement(VisuallyHiddenLegend, null, legend) : /*#__PURE__*/React.createElement("legend", null, legend), React.Children.map(children, function (child, index) {
    return /*#__PURE__*/React.cloneElement(child, {
      name: name,
      checked: selectedIndex === index,
      onChange: function onChange() {
        _onChange(index);
      }
    });
  }));
};

RadioGroup.displayName = 'RadioGroup';
export default RadioGroup;